import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {isEqual} from 'lodash';
import ColumnModel from '../../../../models/datasource/column';
import {
    arrowDownEvent,
    arrowUpEvent,
    inputChangeEvent
} from '../../../../services/query_builder_events';
import {queryBuilderState} from '../../../../services/query_builder_state';
import stopEvent from '../../../../utils/stop_event';

function getPlacementStyles() {
    const inputPos = queryBuilderState.getInputPosition();
    return {
        top: inputPos.bottom,
        left: inputPos.left,
        maxWidth: window.innerWidth - inputPos.left - 50,
    };
}

export default class AttributeMenu extends Component {
    state = {
        searchQuery: '',
        placementStyles: {
            top: 50,
            left: 0,
            maxWidth: '50%',
        },
    };
    menu = null;

    componentDidMount() {
        this.unbindSearchListener = inputChangeEvent.listen((searchQuery) => {
            this.setState({searchQuery});
        });
        this.unbindDownArrowListener = arrowDownEvent.listen(() => {
            if (this.shouldConsumeArrowKeys()) {
                this.updateSelectedItem(1);
            }
        });
        this.unbindUpArrowListener = arrowUpEvent.listen(() => {
            if (this.shouldConsumeArrowKeys()) {
                this.updateSelectedItem(-1);
            }
        });
        this.setState({placementStyles: getPlacementStyles()});
    }

    componentDidUpdate() {
        setTimeout(() => {
            const newPlacementStyles = getPlacementStyles();
            if (!isEqual(newPlacementStyles, this.state.placementStyles)) {
                this.setState({placementStyles: newPlacementStyles});
            }
        }, 100);
    }

    componentWillUnmount() {
        this.unbindSearchListener();
        this.unbindDownArrowListener();
        this.unbindUpArrowListener();
    }

    shouldConsumeArrowKeys() {
        return true;
    }

    updateSelectedItem(delta) {
        // pass
    }

    renderMenu() {
        return null;
    }

    render() {
        const menu = this.renderMenu();
        if (menu) {
            return (
                <div
                    className={`databar-dropdown databar-${this.constructor.name.toLowerCase()}`}
                    style={this.state.placementStyles}
                    onClick={stopEvent}
                    ref={(el) => {
                        this.menu = el;
                    }}
                >
                    {menu}
                </div>
            );
        }
        return null;
    }
}

AttributeMenu.propTypes = {
    column: PropTypes.instanceOf(ColumnModel).isRequired,
};
